import { render } from "./ocr-comp.vue?vue&type=template&id=7384b632"
import script from "./ocr-comp.vue?vue&type=script&lang=js"
export * from "./ocr-comp.vue?vue&type=script&lang=js"

import "./ocr-comp.vue?vue&type=style&index=0&id=7384b632&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QBtn});
